import * as z from 'zod'
import {buildEntrySchemaFor} from '../entry'
import {RichTextSchema} from '../richText'
import {LinkSchema} from './link'
import {AppStoreButtonSchema} from './appStoreButton'
import {BackgroundImageSchema} from './backgroundImage'
import {AssetLinkSchema} from './assetLink'

export const PrimerComponentCtaBannerSchema = buildEntrySchemaFor('primerComponentCtaBanner', {
  fields: z.lazy(() =>
    z.object({
      align: z.enum(['start', 'center']),
      heading: z.string(),
      headingLevel: z.enum(['h2', 'h3', 'h4', 'h5', 'h6']).optional(),
      headingSize: z.enum(['2', '3', '4', '5', '6']).optional(),
      description: RichTextSchema.optional(),
      hasBorder: z.boolean().optional(),
      hasShadow: z.boolean().optional(),
      backgroundImage: BackgroundImageSchema.optional(),
      hasBackground: z.boolean().optional(),
      backgroundColor: z.enum(['default', 'subtle']).optional(),
      callToActionPrimary: z.union([LinkSchema, AssetLinkSchema]),
      callToActionPrimaryVariant: z.enum(['primary', 'accent']).optional(),
      callToActionSecondary: z.union([LinkSchema, AssetLinkSchema]).optional(),
      trailingComponent: z.array(AppStoreButtonSchema).optional(),
    }),
  ),
})

export type PrimerComponentCtaBanner = z.infer<typeof PrimerComponentCtaBannerSchema>
